import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Box, Breadcrumbs, Button, FormControl, InputLabel,
  MenuItem, Select, Typography,
} from '@mui/material';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import Papa from 'papaparse';
import AppShell from './components/AppShell';
import api from './services/api';
import DisqualifyStatus from './disqualify/DisqualifyStatus';
import useDisqualify from './disqualify/useDisqualify';

const DisqualIDs = () => {
  const { surveyId } = useParams();
  const [survey, setSurvey] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState('');
  const disq = useDisqualify(surveyId);

  useEffect(() => {
    api.get(`/surveys/${surveyId}/`).then((res) => setSurvey(res.data));
  }, [surveyId]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      complete: (result) => {
        setCsvData(result.data);
        setSelectedColumn(result.data[0] ? Object.keys(result.data[0])[0] : '');
      },
    });
  };

  const handleDisqualify = async (e) => {
    e.preventDefault();
    const ids = csvData.map((row) => row[selectedColumn]).filter(Boolean);
    await disq.run(ids);
  };

  if (!survey) return null;

  return (
    <AppShell maxWidth="sm">
      <Breadcrumbs separator=">" sx={{ mb: 4 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link>
        <Link to={`/project/${survey.project}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.project_name}</Link>
        <Link to={`/survey/${surveyId}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.name}</Link>
        <Typography color="textPrimary">Disqualify IDs</Typography>
      </Breadcrumbs>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
        <CancelRoundedIcon color="primary" />
        <Typography variant="h4" fontFamily="'Work Sans', sans-serif" fontWeight={700}>
          Disqualify IDs
        </Typography>
      </Box>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Upload a CSV containing Response IDs, then select the column with those IDs.
      </Typography>

      <Box
        sx={{
          bgcolor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 3,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Box component="form" onSubmit={handleDisqualify} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>Upload CSV</Typography>
            <input type="file" accept=".csv" onChange={handleFileUpload} />
          </Box>
          {csvData.length > 0 && (
            <FormControl fullWidth>
              <InputLabel>Choose Column</InputLabel>
              <Select value={selectedColumn} label="Choose Column" onChange={(e) => setSelectedColumn(e.target.value)}>
                {Object.keys(csvData[0]).map((col) => <MenuItem key={col} value={col}>{col}</MenuItem>)}
              </Select>
            </FormControl>
          )}
          <Button
            type="submit"
            variant="contained"
            disabled={!csvData.length || disq.running}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Disqualify IDs
          </Button>
        </Box>

        <DisqualifyStatus state={disq} surveyId={surveyId} />
      </Box>
    </AppShell>
  );
};

export default DisqualIDs;
